/**
 * Toggles send button classes based on the value of the text input.
 * If the value is not empty, it adds the active class and removes the inactive class.
 * If the value is empty, it adds the inactive class and removes the active class.
 * If forceInactive is true, it adds the inactive class and removes the active class.
 * @param {{e: object, me: object, activeClass: string, inactiveClass: string, forceInactive: boolean}} options
 * @param {object} options.e - The event object.
 * @param {object} options.me - The instance of the ChatUIController class.
 * @param {string} [options.activeClass='livechat_send_message_button_active'] - The class name to add to the send button when active.
 * @param {string} [options.inactiveClass='livechat_send_message_button_inactive'] - The class name to add to the send button when inactive.
 * @param {boolean} [options.forceInactive=false] - Whether to remove the active class regardless of the value of the text input.
 */
const toggleSendButtonClasses = (props) => {
    const {
        e = {},
        me = {},
        activeClass = 'livechat_send_message_button_active',
        inactiveClass = 'livechat_send_message_button_inactive',
        forceInactive = false,
    } = props;
    const value = e?.target?.value;
    if (value?.length > 0) {
        me.clickButton.classList.add(activeClass);
        me.clickButton.classList.remove(inactiveClass);
    } else {
        me.clickButton.classList.add(inactiveClass);
        me.clickButton.classList.remove(activeClass);
    }
    if (forceInactive) {
        me.clickButton.classList.add(inactiveClass);
        me.clickButton.classList.remove(activeClass);
    }
}
export default toggleSendButtonClasses;
